import { render, staticRenderFns } from "./LaserPage.vue?vue&type=template&id=c5ddac40&scoped=true"
import script from "./LaserPage.vue?vue&type=script&lang=js"
export * from "./LaserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ddac40",
  null
  
)

export default component.exports